function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { default as MuiExpansionPanelActions } from '@material-ui/core/ExpansionPanelActions';
import ExpansionPanelContext from './internal/ExpansionPanelContext';
import { spacingVariant } from './../globalSpacing';

import { spacing40, spacing50 } from '../styles/tokens';

var styles = function styles(theme) {
    return {
        root: _defineProperty({
            padding: spacing40 + ' ' + spacing40 + ' ' + spacing40
        }, theme.breakpoints.up('lg'), {
            padding: spacing50 + ' ' + spacing50 + ' ' + spacing50
        }),
        none: {
            padding: 0
        }
    };
};

/**
 * A component that....
 */
var ExpansionPanelActions = React.forwardRef(function (props, ref) {
    var _useContext = useContext(ExpansionPanelContext),
        spacing = _useContext.spacingOptions.spacing;

    var classes = props.classes,
        rest = _objectWithoutProperties(props, ['classes']);

    var classOverrides = {
        root: classNames(classes.root, _defineProperty({}, classes.none, spacing === spacingVariant.NONE))
    };

    return React.createElement(MuiExpansionPanelActions, Object.assign({}, rest, {
        classes: classOverrides,
        ref: ref
    }));
});

ExpansionPanelActions.muiName = 'ExpansionPanelActions';
ExpansionPanelActions.displayName = 'ExpansionPanelActions';

ExpansionPanelActions.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object.isRequired,
    /**
     * @ignore
     */
    className: PropTypes.string
};

// If default props are needed, they must be set here
// ExpansionPanelActions.defaultProps = { };

export default withStyles(styles)(ExpansionPanelActions);